<template>
  <div>
    <div class="bg-white py-6">
      <!-- Replace with your content -->
      <div>
        <div class="md:flex md:items-center md:justify-between sm:px-6 md:px-8">
          <div class="flex-1 min-w-0">
            <h2 class="text-2xl font-bold leading-7 text-gray-800 sm:text-3xl sm:truncate">
              {{ $t("messages.approvePayout.approvePayout") }}
            </h2>
          </div>
          <div class="mt-4 flex-shrink-0 flex md:mt-0 md:ml-4"></div>
        </div>
      </div>
    </div>
    <!-- /End replace -->

    <nav class="bg-white border-b border-t border-gray-200 flex" aria-label="Breadcrumb">
      <ol class="w-full mx-auto px-4 flex space-x-4 sm:px-6 md:px-8">
        <li class="flex">
          <div class="flex items-center">
            <a href="javascript:void(0)" class="text-gray-400 hover:text-gray-500">
              <HomeIcon class="flex-shrink-0 h-5 w-5" aria-hidden="true" />
              <span class="sr-only">Home</span>
            </a>
          </div>
        </li>
        <li v-for="page in pages" :key="page.name" class="flex">
          <div class="flex items-center">
            <svg
              class="flex-shrink-0 w-6 h-full text-gray-200"
              viewBox="0 0 24 44"
              preserveAspectRatio="none"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path d="M.293 0l22 22-22 22h1.414l22-22-22-22H.293z" />
            </svg>
            <router-link
              :to="page.href"
              class="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
              :aria-current="page.current ? 'page' : undefined"
              >{{ page.name }}</router-link
            >
          </div>
        </li>
      </ol>
    </nav>

    <div class="">
      <div class="space-y-8 divide-y divide-gray-200 bg-white py-3 border-b text-center overflow-x-auto">
        <div class="md:flex md:items-center md:justify-between">
          <div class="flex-1 px-2 flex md:flex-row flex-col justify-center lg:ml-6 lg:justify-start mx-auto">
            <div class="md:max-w-lg w-full md:w-64 lg:max-w-xs">
              <div class="relative text-gray-600 focus-within:text-gray-600">
                <div class="pointer-events-none absolute inset-y-0 pl-1 left-0 flex items-center">
                  {{ $t("messages.approvePayout.from") }}:
                </div>
                <input
                  id="from"
                  v-model="fromDate"
                  maxlength="10"
                  @change="search($event)"
                  class="block w-full bg-white py-2 pl-14 focus:bg-white pr-3 border border-transparent rounded-md leading-5 text-gray-900 placeholder-gray-500 focus:ring-offset-blue-600 focus:ring-white focus:border-white sm:text-sm"
                  placeholder="From"
                  type="datetime-local"
                  name="from"
                />
              </div>
            </div>
            <div class="max-w-lg w-full md:w-64 lg:max-w-xs">
              <div class="relative text-gray-600 focus-within:text-gray-600">
                <div class="pointer-events-none absolute inset-y-0 pl-1 left-0 flex items-center">
                  {{ $t("messages.approvePayout.to") }}:
                </div>
                <input
                  id="from"
                  v-model="toDate"
                  maxlength="10"
                  @change="search($event)"
                  class="block w-full bg-white py-2 pl-14 focus:bg-white pr-3 border border-transparent rounded-md leading-5 text-gray-900 placeholder-gray-500 focus:ring-offset-blue-600 focus:ring-white focus:border-white sm:text-sm"
                  placeholder="To"
                  type="datetime-local"
                  name="to"
                />
              </div>
            </div>
          </div>
          <div class="flex items-center md:mr-5 gap-5 w-full justify-center">
            <div class="flex items-center mr-5">
              {{ $t("messages.approvePayout.notification") }}:
              <!-- {{
                        userRoles
                          ? userRoles.toString()
                          : "-"
                      }} -->
              <Switch
                style="height: 20px; width: 40px"
                :v-model="isNotified"
                @click="updateNotification()"
                :class="isNotified ? 'bg-blue-500' : 'bg-red-900'"
                class="ml-3 relative inline-flex flex-shrink-0 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75"
              >
                <span
                  style="width: 16px; height: 16px"
                  :class="isNotified ? 'translate-x-5' : 'translate-x-0'"
                  class="pointer-events-none inline-block rounded-full bg-white shadow-lg transform ring-0 transition ease-in-out duration-200"
                />
              </Switch>
            </div>
            <div>
              <select v-if="payments.length > 1" class="rounded" v-model="selected_payment" @change="changePayment">
                <option v-for="(payment, index) in payments" :value="payment" :key="index">
                  {{ payment }}
                </option>
              </select>
              <div v-else>{{ selected_payment }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="px-8 py-6" v-show="!isLoaded">
      <div class="space-y-8 divide-y divide-gray-200 bg-white px-10 py-9 rounded-md shadow-md text-center">
        <font-awesome-icon class="text-gray-500" :icon="['fas', 'circle-notch']" transform="grow-6" spin />
      </div>
    </div>

    <div class="py-6" v-show="isLoaded">
      <div class="sm:px-6 md:px-8">
        <div class="bg-white shadow sm:rounded-md">
          <div class="shadow overflow-x-auto border-b border-gray-200 sm:rounded-lg">
            <table class="table min-w-full divide-y divide-gray-200">
              <thead class="bg-gray-50">
                <tr>
                  <th
                    scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    {{ $t("messages.approvePayout.customerPhone") }}
                  </th>
                  <th
                    scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    {{ $t("messages.approvePayout.amount") }}
                  </th>
                  <th
                    scope="col"
                    class="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider text-center"
                  >
                    {{ $t("messages.approvePayout.date") }}
                  </th>
                  <th
                    scope="col"
                    class="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider text-center"
                  >
                    {{ $t("messages.approvePayout.status") }}
                  </th>
                  <th
                    scope="col"
                    class="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider text-center"
                  ></th>
                </tr>
              </thead>
              <tbody class="bg-white divide-y divide-gray-200">
                <tr v-for="data in dataRows" :key="data.deposit_id" class="hover:bg-gray-50">
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    <p
                      class="hover:underline cursor-pointer"
                      @click="$router.push(`/players?page=1&rowsPerPage=10&username=${data.customer_code}`)"
                    >
                      {{ data.customer_code }}
                    </p>
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-left">
                    {{
                      Number(data.withdraw_money).toLocaleString("en", {
                        useGrouping: true,
                        minimumFractionDigits: 2,
                      })
                    }}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-center">
                    {{ getLocaleDate(data.createdate) }}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-center">
                    {{ data.status }}
                  </td>
                  <td class="text-right">
                    <button
                      type="button"
                      v-if="store.state.user.permissions.includes('OPERATOR.READ.FINANCE_APPROVE_PAYOUT')"
                      @click="toggleModal(data)"
                      class="mr-5 inline-flex items-center px-2 py-1 border border-transparent rounded-md shadow-sm text-xs font-medium text-white bg-red-500 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-red-500"
                    >
                      {{ $t("messages.approvePayout.approvePayout") }}
                    </button>
                    <!-- <button type="button" @click="rejectTransaction(data)" class="mr-5 inline-flex items-center px-2 py-1 border border-transparent rounded-md shadow-sm text-xs font-medium text-white bg-red-500 hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-red-500">
                      Reject Payout
                    </button> -->
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6">
              <div class="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
                <!-- <div>
                  <Listbox as="div" v-model="rowsPerPage">
                    <ListboxButton
                      class="bg-white relative w-full border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                    >
                      <span class="block truncate">{{
                        rowsPerPage.value
                      }}</span>
                      <span
                        class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none"
                      >
                        <SelectorIcon
                          class="h-5 w-5 text-gray-400"
                          aria-hidden="true"
                        />
                      </span>
                    </ListboxButton>
                    <ListboxOptions
                      class="absolute z-10 mt-1 w-44 bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm"
                    >
                      <ListboxOption
                        as="template"
                        v-for="(option, index) in rowsPerPageOption"
                        :key="index"
                        :value="option"
                        @click="refetch()"
                      >
                        <li
                          :class="[
                            'hover:text-white hover:bg-indigo-600 text-gray-900 cursor-default select-none relative py-2 pl-3 pr-9',
                          ]"
                        >
                          <span>
                            {{ option.label }}
                          </span>
                        </li>
                      </ListboxOption>
                    </ListboxOptions>
                  </Listbox>
                  <p class="text-sm text-gray-700">
                    Showing
                    {{ " " }}
                    <span class="font-medium">{{ offset + 1 }}</span>
                    {{ " " }}
                    to
                    {{ " " }}
                    <span class="font-medium">{{
                      offset + dataRows.length
                    }}</span>
                    {{ " " }}
                    of
                    {{ " " }}
                    <span class="font-medium">{{ dataCount }}</span>
                    {{ " " }}
                    results
                  </p>
                </div> -->
                <div>
                  <nav class="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination">
                    <a
                      href="javascript:void(0)"
                      @click="jump(1)"
                      class="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
                    >
                      <span class="sr-only">First</span>
                      <span class="h-5 w-5 text-center"
                        ><font-awesome-icon
                          class="text-gray-500"
                          :icon="['fas', 'chevron-double-left']"
                          transform="shrink-2"
                      /></span>
                    </a>
                    <a
                      href="javascript:void(0)"
                      @click="prev"
                      class="relative inline-flex items-center px-2 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
                    >
                      <span class="sr-only">Previous</span>
                      <span class="h-5 w-5 text-center"
                        ><font-awesome-icon class="text-gray-500" :icon="['fas', 'chevron-left']" transform="shrink-2"
                      /></span>
                    </a>
                    <a
                      href="javascript:void(0)"
                      @click="jump(paginationOffset(i))"
                      v-for="i in pageCount()"
                      :key="i"
                      :class="
                        currentPage === i
                          ? 'z-10 bg-indigo-50 border-indigo-500 text-indigo-600 relative inline-block items-center py-2 w-10 text-center border text-sm font-medium'
                          : 'bg-white border-gray-300 text-gray-500 hover:bg-gray-50 relative inline-block items-center py-2 w-10 text-center border text-sm font-medium'
                      "
                      :style="{
                        display: Math.abs(i - currentPage) < 2 || i == 0 ? 'block' : 'none',
                      }"
                      style="cursor: pointer"
                    >
                      {{ i }}
                    </a>
                    <a
                      href="javascript:void(0)"
                      @click="next"
                      class="relative inline-flex items-center px-2 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
                    >
                      <span class="sr-only">Next</span>
                      <span class="h-5 w-5 text-center"
                        ><font-awesome-icon class="text-gray-500" :icon="['fas', 'chevron-right']" transform="shrink-2"
                      /></span>
                    </a>
                    <a
                      href="javascript:void(0)"
                      @click="jump(Math.ceil(dataCount / rowsPerPage.value))"
                      class="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
                    >
                      <span class="sr-only">Last</span>
                      <span class="h-5 w-5 text-center"
                        ><font-awesome-icon
                          class="text-gray-500"
                          :icon="['fas', 'chevron-double-right']"
                          transform="shrink-2"
                      /></span>
                    </a>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <TransitionRoot as="template" :show="approveModalOpen">
      <Dialog
        as="div"
        static
        class="fixed z-10 inset-0 overflow-y-auto"
        @close="approveModalOpen = false"
        :open="approveModalOpen"
      >
        <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <TransitionChild
            as="template"
            enter="ease-out duration-300"
            enter-from="opacity-0"
            enter-to="opacity-100"
            leave="ease-in duration-200"
            leave-from="opacity-100"
            leave-to="opacity-0"
          >
            <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </TransitionChild>

          <!-- This element is to trick the browser into centering the modal contents. -->
          <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
          <TransitionChild
            as="template"
            enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div
              class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full sm:p-6"
            >
              <div>
                <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
                  <font-awesome-icon class="text-green-600" :icon="['far', 'check']" transform="grow-2" />
                </div>
                <div class="mt-2 text-center sm:mt-5">
                  <DialogTitle as="h3" class="text-lg leading-6 font-medium text-gray-900">
                    {{ $t("messages.approvePayout.approvePayout") }}
                    <!-- <small class="text-gray-400">{{ userInfo.username }}</small> -->
                  </DialogTitle>
                  <div class="rounded-md bg-red-50 p-4 text-left mt-3" v-show="hasError">
                    <div class="flex">
                      <div class="flex-shrink-0">
                        <XCircleIcon class="h-5 w-5 text-red-400" aria-hidden="true" />
                      </div>
                      <div class="ml-3">
                        <h3 class="text-sm font-medium text-red-800">
                          {{ errorMessage }}
                        </h3>
                      </div>
                    </div>
                  </div>
                  <div class="pt-5 text-left">
                    <b> {{ $t("messages.approvePayout.bankAccountName") }}</b
                    >: {{ selected.bank_no || "-" }}<br />
                    <b>{{ $t("messages.approvePayout.bankNo") }}.</b>: {{ selected.bank_name || "-" }}<br />
                    <b>{{ $t("messages.approvePayout.customerPhone") }}</b
                    >: {{ selected.customer_code || "-" }}<br />
                    <!-- <b>Deposit ID</b>: {{ selected.deposit_id || '-' }}<br>
                    <b>Member ID</b>: {{ selected.member_id || '-' }}<br> -->
                    <b>{{ $t("messages.approvePayout.createDate") }}</b
                    >: {{ dayjs(selected.createdate).locale("th").format("LLL") || "-" }}<br />
                    <b>{{ $t("messages.approvePayout.status") }}</b
                    >: {{ selected.status || "-" }}<br />
                  </div>
                  <div class="mt-6 pb-2 text-left">
                    <label class="text-sm">{{ $t("messages.approvePayout.approveAmount") }}</label>
                    <div class="mt-1">
                      <span
                        class="inline-block border-2 px-2 py-2 shadow-sm block w-full sm:text-sm border-gray-300 rounded-md"
                        >{{ selected.withdraw_money }}</span
                      >
                    </div>
                  </div>
                  <div v-if="isCheckTOTP" class="flex flex-col justify-center mb-2 mt-4">
                    <span>{{ $t("messages.logIn.inputTotp") }}</span>
                    <span v-if="currentAttempts > 0" class="text-red-600">
                      ใส่ผิดไปแล้ว {{ currentAttempts }} ครั้ง
                    </span>
                    <input
                      type="text"
                      v-model="totp"
                      class="rounded"
                      maxlength="6"
                      :placeholder="$t('messages.logIn.totpCode')"
                    />
                  </div>
                </div>
              </div>
              <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                <button
                  v-if="isCheckTOTP"
                  class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:col-start-2 sm:text-sm"
                  @click="onCheckTOTP"
                >
                  <font-awesome-icon class="text-gray-500" :icon="['fas', 'circle-notch']" transform="grow-6" spin />
                  <p>Approve</p>
                </button>
                <button
                  v-if="!isCheckTOTP"
                  type="button"
                  :disabled="isWorking"
                  @click="
                    Number(selected.withdraw_money) >= maxValueToNoRequireOtp ? (isCheckTOTP = true) : saveTransaction()
                  "
                  class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:col-start-2 sm:text-sm"
                >
                  <font-awesome-icon
                    v-if="isWorking"
                    class="text-gray-500"
                    :icon="['fas', 'circle-notch']"
                    transform="grow-6"
                    spin
                  />
                  <p v-else>{{ $t("messages.approvePayout.confirmPayout") }}</p>
                </button>
                <button
                  type="button"
                  @click="toggleModal()"
                  class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                  ref="cancelButtonRef"
                >
                  {{ $t("messages.approvePayout.cancel") }}
                </button>
              </div>
            </div>
          </TransitionChild>
        </div>
      </Dialog>
    </TransitionRoot>
  </div>
</template>

<script>
import {
  CheckCircleIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  MailIcon,
  HomeIcon,
  SearchIcon,
  XCircleIcon,
  SelectorIcon,
  CheckIcon,
} from "@heroicons/vue/solid";
import {
  Dialog,
  DialogOverlay,
  DialogTitle,
  TransitionChild,
  TransitionRoot,
  Listbox,
  ListboxButton,
  ListboxLabel,
  ListboxOption,
  ListboxOptions,
} from "@headlessui/vue";
import { inject, onMounted, ref } from "@vue/runtime-core";
import { useStore } from "vuex";
import * as dayjs from "dayjs";
import "dayjs/locale/th";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { useRoute, useRouter } from "vue-router";
import { Switch } from "@headlessui/vue";

dayjs.extend(localizedFormat);

const pages = [{ name: "Approve Payout", href: "", current: true }];

export default {
  components: {
    ChevronLeftIcon,
    ChevronRightIcon,
    CheckCircleIcon,
    XCircleIcon,
    MailIcon,
    HomeIcon,
    SearchIcon,
    Dialog,
    DialogOverlay,
    DialogTitle,
    TransitionChild,
    TransitionRoot,
    Listbox,
    ListboxButton,
    ListboxLabel,
    ListboxOption,
    ListboxOptions,
    SelectorIcon,
    CheckIcon,
    Switch,
  },
  setup() {
    const axios = inject("$axios");
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const fromDate = ref("");
    const toDate = ref("");
    let approveModalOpen = ref(false);
    let dataRows = ref([]);
    let dataCount = ref(0);
    let isLoaded = ref(false);
    const isWorking = ref(false);
    const selected = ref({});
    let hasError = ref(false);
    let errorMessage = ref("");
    const isNotified = ref(store.state.user.payoutNotification);
    const rowsPerPage = ref({ label: "10", value: 10 });
    const currentPage = ref(route.query.page);
    const currentAttempts = ref(0);

    const totp = ref("");
    const isCheckTOTP = ref(false);
    const maxValueToNoRequireOtp = ref(0);
    // const rowsPerPageOption = [
    //   { label: "5", value: 5 },
    //   { label: "10", value: 10 },
    //   { label: "20", value: 20 },
    //   { label: "30", value: 30 },
    //   { label: "40", value: 40 },
    // ]

    let payments = ref(["PAYDUTY", "RTB"]);

    const selected_payment = ref();

    onMounted(() => {
      axios
        .post(
          process.env.VUE_APP_API_ENDPOINT +
          "/admin/api/v1/operator-admin/get-operator-profile-user",
          {
            id: store.state.user.id,
          },
          {
            headers: {
              "x-cm-forwarded-for": store.state.user.ip,
            },
          }
        )
        .then((operator) => {
          const currentOperatorConfig = operator.data.result.find(res => res.operatorId == store.state.selectedOperator.operatorId)
          maxValueToNoRequireOtp.value = currentOperatorConfig.approvePayoutTotpAmount || 0
        })
        .catch((err) => {
          console.log(error)
        });
      // maxValueToNoRequireOtp.value = store.state.selectedOperator.approvePayoutTotpAmount;
      if (store.state.user.payment) selected_payment.value = store.state.user.payment;
      else selected_payment.value = payments.value[0];
      // console.log('selected_payment.value', selected_payment.value);
      refetch();
      // setTimeout(() => {
      //   refetch();
      // }, 60000);
    });

    const updateNotification = () => {
      const notification = isNotified.value ? false : true;
      isNotified.value = notification;
      store.commit("serUserPayoutNotification", notification);
    };

    const refetch = () => {
      currentPage.value = currentPage.value || 1;
      if (selected_payment.value == "RTB") {
        changePayment(selected_payment.value);
      } else {
        axios
          .get(
            process.env.VUE_APP_API_ENDPOINT +
              "/admin/api/v1/transactions/pending/withdraw/" +
              store.state.selectedOperator.operatorId
          )
          .then(({ data }) => {
            if (data.list) {
              dataRows.value = data.list;
            } else {
              dataRows.value = [];
            }

            dataCount.value = data.total_records;
            isLoaded.value = true;
          })
          .catch(({ response }) => {
            dataRows.value = [];
            // alert("ไม่มีข้อมูลที่สามารถแสดงได้");
            isLoaded.value = true;
          });
      }
    };

    const changePayment = (payment) => {
      if (payment.target?.value) store.commit("setUserPayment", payment.target?.value);
      if (payment == "RTB") {
        isLoaded.value = false;
        axios
          .get(
            process.env.VUE_APP_API_ENDPOINT +
              "/admin/api/v1/internal/rtb/internal/withdraws/pending-list/" +
              store.state.selectedOperator.operatorId +
              "?page=" +
              currentPage.value
          )
          .then(({ data }) => {
            // console.log(data)
            if (data) {
              build(data);

              dataCount.value = data.totalResults;
              isLoaded.value = true;
            } else {
              dataRows.value = [];
              dataCount.value = 0;
            }
          })
          .catch((err) => {
            dataRows.value = [];
            dataCount.value = 0;
            // console.log(err);
            isLoaded.value = true;
          });
      } else {
        refetch();
      }
    };

    const paginationOffset = (i) => {
      const page = Math.ceil(dataCount.value / 10) >= i ? i : Math.ceil(dataCount.value / 10);
      return page;
    };

    const build = (data) => {
      let returner = [];
      for (let i = 0; i < data.results.length; i++) {
        returner.push({
          customer_code: data.results[i].member ? data.results[i].member.telephoneNumber : "-",
          withdraw_money: data.results[i].amount,
          deposit_id: data.results[i].id,
          bank: data.results[i].bank ? data.results[i].bank.code : data.results[i].bankId,
          bank_name: data.results[i].member ? data.results[i].member.bankAccountNumber : "",
          bank_no: data.results[i].member ? data.results[i].member.bankAccountName : "-",
          createdate: data.results[i].createdAt,
          member_id: data.results[i].memberId,
          status: data.results[i].remark,
        });
      }

      dataRows.value = returner;
    };

    const getLocaleDate = (date) => {
      return dayjs(date).locale("th").format("LLL");
    };

    const search = (e) => {
      let from = dayjs(fromDate.value);
      let to = dayjs(toDate.value);

      if (
        (e.code == "Enter" || e.code == "NumpadEnter" || e.type == "change" || e.keyCode == 13) &&
        from.isValid() &&
        to.isValid() &&
        from.isBefore(to)
      ) {
        isLoaded.value = false;

        axios
          .get(
            process.env.VUE_APP_API_ENDPOINT +
              "/admin/api/v1/transactions/pending/withdraw/" +
              store.state.selectedOperator.operatorId
          )
          .then(({ data }) => {
            if (data.result.data.length == 1) {
              router.push({
                name: "Wallet Info",
                params: { id: data.result.data[0].id },
              });
              return;
            }

            dataRows.value = data.list;
            dataCount.value = data.total_records;
            isLoaded.value = true;
          })
          .catch((err) => {
            console.log(err);
            isLoaded.value = true;
          });
      }
    };

    const jump = (page) => {
      currentPage.value = page;
      // offset.value = (page - 1) * rowsPerPage.value.value
      router.push({ query: { page: currentPage.value } });
      route.query.page = page;
      refetch();
    };

    const prev = () => {
      const page = parseInt(route.query.page) - 1;
      if (route.query.page && route.query.page !== "1") {
        router
          .push({
            query: {
              page: page,
            },
          })
          .then(() => {
            refetch();
          });
      }
      currentPage.value = page;
    };

    const pageCount = (i) => {
      return Math.ceil(dataCount.value / rowsPerPage.value.value);
    };

    const next = () => {
      const page = parseInt(route.query.page) + 1 || 2;
      router
        .push({
          query: {
            page: page,
          },
        })
        .then(() => {
          refetch();
        });
      route.query.page = page;
      currentPage.value = page;
    };

    const toggleModal = (data) => {
      if (data) {
        selected.value = data;
      }
      hasError.value = false;
      errorMessage.value = "";
      totp.value = "";
      isCheckTOTP.value = false;
      approveModalOpen.value = !approveModalOpen.value;
    };

    const saveTransaction = () => {
      isWorking.value = true;
      if (selected_payment.value == "RTB") {
        //RTB

        axios
          .post(process.env.VUE_APP_API_ENDPOINT + "/admin/api/v1/internal/rtb/internal/withdraws/approve", {
            rtb_id: selected.value.deposit_id,
            user_phone: selected.value.customer_code,
            admin_id: store.state.user.username,
            member_id: selected.value.memberId,
            operator_id: store.state.selectedOperator.operatorId,
          })
          .then(({ data }) => {
            if (data.error) {
              hasError.value = true;
              errorMessage.value = data.message || data.remark;
              isWorking.value = false;
            } else {
              refetch();
              isWorking.value = false;
              alert("กรุณารอสักครู่ ระบบกำลังทำเรื่องขอถอนเงินให้ท่านอยู่");
              approveModalOpen.value = !approveModalOpen.value;
            }

            // if (data.success) {
            //   refetch();
            //   isWorking.value = false;
            //   approveModalOpen.value = !approveModalOpen.value;
            // } else {
            //   hasError.value = true;
            //   errorMessage.value = data.remark || data.msg;
            //   isWorking.value = false;
            // }
          })
          .catch((err) => {
            console.log(err);
            hasError.value = true;
            errorMessage.value = err.response.data.message;
            isWorking.value = false;
          });
      } else {
        axios
          .post(process.env.VUE_APP_API_ENDPOINT + "/admin/api/v1/transactions/pending/withdraw", {
            id: selected.value.withdraw_id,
            customer_code: selected.value.customer_code,
            username: store.state.user.username,
            operatorId: store.state.selectedOperator.operatorId,
          })
          .then(({ data }) => {
            if (data.success) {
              refetch();
              isWorking.value = false;
              approveModalOpen.value = !approveModalOpen.value;
            } else {
              hasError.value = true;
              errorMessage.value = data.msg;
              isWorking.value = false;
            }
          })
          .catch((err) => {
            console.log(err);
            hasError.value = true;
            errorMessage.value = err.response.data.message;
            isWorking.value = false;
          });
      }
    };

    const rejectTransaction = (data) => {
      if (confirm(`Reject payout for user ${data.customer_code} amount ${data.withdraw_money}THB ?`)) {
        // axios.post(process.env.VUE_APP_API_ENDPOINT + '/transactions/pending/withdraw',{
        //   id: selected.value.withdraw_id,
        //   customer_code: selected.value.customer_code
        // })
        // .then(({ data }) => {
        //   refetch()
        //   isWorking.value = false;
        //   approveModalOpen.value = !approveModalOpen.value
        // })
        // .catch(err => {
        //   console.log(err);
        //   isWorking.value = false;
        // })
      }
    };

    const onCheckTOTP = async () => {
      try {
        await axios.post(
          `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/auth/admin-totp-check`,
          {
            requestId: Date.now().toString(),
            requestTs: Date.now(),
            code: totp.value,
            userId: store.state.user.id,
            callerFunction: "Confirm Approve Payout",
          },
          { headers: { "x-cm-forwarded-for": store.state.user.ip } }
        );
        saveTransaction();
      } catch (e) {
        if (e?.response?.data?.isBlackList) {
          store.commit("removeUserInfo");
          store.commit("removeOperators");
          router.push({ name: "Login" });
          window.location.reload();
        } else if (e?.response?.data?.attempts) {
          currentAttempts.value = e.response.data.attempts;
        }
        alert("รหัส Google Authenticator ไม่ถูกต้อง");
      }
    };

    return {
      dataRows,
      dataCount,
      isLoaded,
      dayjs,
      fromDate,
      toDate,
      route,
      search,
      getLocaleDate,
      pages,
      toggleModal,
      approveModalOpen,
      isWorking,
      selected,
      saveTransaction,
      rejectTransaction,
      hasError,
      errorMessage,
      selected_payment,
      payments,
      changePayment,
      updateNotification,
      isNotified,
      store,
      pageCount,
      rowsPerPage,
      // rowsPerPageOption,
      refetch,
      currentPage,
      prev,
      next,
      jump,
      paginationOffset,
      /** TOTP handlers */
      totp,
      isCheckTOTP,
      onCheckTOTP,
      currentAttempts,
      maxValueToNoRequireOtp,
    };
  },
};
</script>
